<script >
import {defineComponent} from 'vue'

export default defineComponent({
  name: "AuthorizeSuccessful"
})
</script>

<template>
  <div>
    <div class="wrapper">
        <img src="@/assets/invoiceUploadV2SuccessFromEit.png" style="width: 120px;">
        <div class="text">数据授权已完成，请前往上传数据</div>

    </div>
  </div>

</template>

<style scoped lang="stylus">
.wrapper{
  display flex;
  justify-content center
  align-items center
  height 80vh
  flex-direction column
}
.text{
  margin-top 30px
  color: #0E1429;
  font-weight: 600;
  font-size: 16px;
}
</style>
